import React from 'react'
import { graphql, Script, ScriptStrategy } from 'gatsby'
import SEO from '@toasttab/otl/src/components/Common/SEO/SEO'
import MDSEntry from '@toasttab/otl/src/components/MDS/Entry/mdsEntry'
import {
  getLanguageByCountryCode,
  getLocalizedEntries
} from '@toasttab/shared/src/utils/siteUtils'

export const query = graphql`
  query (
    $locale: String!
    $region: String!
    $slug: String!
    $subscribeImageFileName: String!
  ) {
    allContentfulSimpleEntry(
      filter: {
        node_locale: { eq: $locale }
        regions: { elemMatch: { country: { eq: $region } } }
        slug: { eq: $slug }
      }
    ) {
      nodes {
        slug
        title
        regions {
          country
          metaTitle
          metaDescription {
            metaDescription
          }
          showDisclaimer
          blogAuthor {
            ...BlogAuthor
          }
          expertReviewer {
            ...ExpertReviewer
          }
          hero {
            headline
            description {
              description
            }
            image {
              ...Asset
            }
            ctaCopy {
              ctaCopy
            }
            ctas {
              ...GatedLongForm
              ...PromoBlock
            }
          }
          content {
            ...ContentWarning
            ...GeneralBody
            ...GatedLongForm
            ...PromoBlock
            ...CustomCTA
            ...BarGraph
            ...VidyardVideo
            ...InfogramEmbed
            ...Blockquote
            ...TechTips
            ...FeaturedSnippet
            ...FeaturedArticle
            ...RelatedArticles
            ...NewsletterSubscribe
            ...RetailCTA
          }
        }
      }
    }
    allContentfulAsset(filter: { filename: { eq: $subscribeImageFileName } }) {
      nodes {
        ...Asset
      }
    }
    allContentfulFormPage(
      filter: {
        node_locale: { eq: $locale }
        regions: { elemMatch: { country: { eq: $region } } }
        slug: { eq: "email-only" }
      }
    ) {
      nodes {
        slug
        title
        regions {
          country
          content {
            ...FormStep
          }
        }
      }
    }
    allContentfulGlobalPageFooter {
      edges {
        node {
          internalName
          pageFooter {
            country
            ...FooterContent
          }
        }
      }
    }
    allContentfulGlobalSettings {
      edges {
        node {
          globalBanner {
            ...GlobalBanner
          }
        }
      }
    }
  }
`
const OTLEntryVariant = (props: any) => {
  return (
    <MDSEntry
      showArticleFeedback
      entries={props.data.allContentfulSimpleEntry.nodes[0]}
      {...props}
    />
  )
}

export default OTLEntryVariant

export const Head = (props: any) => {
  const { data, pageContext } = props
  const node = data.allContentfulSimpleEntry.nodes[0]
  const regionSite = node.regions.filter(
    (r: any) => r.country === pageContext.region
  )[0]
  let slugOverride = regionSite.slugOverride
    ? regionSite.slugOverride
    : node.slug

  const slug = `${slugOverride}`
  const currentRegion = regionSite.country
  const localizedEntries = getLocalizedEntries(
    slug,
    node.regions,
    currentRegion
  )

  return (
    <SEO
      title={regionSite.metaTitle}
      description={regionSite.metaDescription?.metaDescription}
      language={getLanguageByCountryCode(currentRegion)}
      pathname={`/${slug}`}
      localizedEntries={localizedEntries}
      noIndex={!regionSite.isIndexed}
    >
      <Script
        src='https://play.vidyard.com/embed/v4.js'
        type='text/javascript'
        strategy={ScriptStrategy.postHydrate}
      />
    </SEO>
  )
}
